import api from './api';

export const refreshTokenMutation = () => ({
	mutationFn: async (fcmToken: string) => await api.put(`/api/account/refreshToken`, { fcmToken }),
});
